import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalDialog from '../ModalDialog';
import { applyPlaceholderExamples } from './emailTemplatePlaceholderDefinitions';
import { emailTemplateType } from '../../types';
import './_styles_/EmailTemplatePreview.css';

EmailTemplatePreview.propTypes = {
    emailTemplate: emailTemplateType.isRequired,
    onClose: PropTypes.func.isRequired,
};

function EmailTemplatePreview(props) {
    const { emailTemplate, onClose } = props;
    const { t } = useTranslation();
    return (
        <ModalDialog onCancel={onClose}>
            <div className="email-template-preview">
                <div className="email-template-preview--subject">
                    <h4>
                        <FontAwesomeIcon icon="envelope" />&nbsp;{t('email-templates.preview.title')}
                    </h4>
                    <button
                        type="button"
                        className="email-template-preview--close button"
                        onClick={onClose}
                        aria-label={t('button.close')}
                    >
                        <FontAwesomeIcon icon="times" />
                    </button>
                </div>
                <p className="email-template-preview--note">{t('email-templates.preview.placeholder-note')}</p>
                <dl className="email-template-preview--fields">
                    <dt>{t('email-templates.name')}</dt>
                    <dd>{emailTemplate.name}</dd>
                    <dt>{t('email-templates.subject')}</dt>
                    <dd>{applyPlaceholderExamples(emailTemplate.subject, emailTemplate.locale)}</dd>
                    <dt>{t('email-templates.body')}</dt>
                    <dd className="email-template-preview--body email-template-preview--body-content">{applyPlaceholderExamples(emailTemplate.body, emailTemplate.locale)}</dd>
                </dl>
            </div>
        </ModalDialog>
    );
}

export default EmailTemplatePreview;
